module.exports = __webpack_public_path__ + "img/villa_madina.accf3e26.png";